import {
  CLAIM_CHAT_BY_AGENT_REQUEST,
  CLAIM_CHAT_BY_AGENT_FAILURE,
  CLAIM_CHAT_BY_AGENT_SUCCESS,
} from '../actions/actionTypes';

const initialState = {
  claimChat: {},
  isFetchingClaimChat: false,
  isErrorInClaimVhat: null,
};

const ClaimChat = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case CLAIM_CHAT_BY_AGENT_REQUEST:
        return {
          ...state,
          isFetchingClaimChat: true,
          isErrorInClaimVhat: null,
        };
      case CLAIM_CHAT_BY_AGENT_SUCCESS:
        return {
          ...state,
          isFetchingClaimChat: false,
          claimChat: action.payload,
          isErrorInClaimVhat: null,
        };
      case CLAIM_CHAT_BY_AGENT_FAILURE:
        return {
          ...state,
          isFetchingClaimChat: false,
          isErrorInClaimVhat: 'SomeThing went wrong.',
        };
      default:
        return state;
    }
  }
};

export default ClaimChat;
